import i18next from 'i18next';

export function getLanguageName(language: string) {
  return i18next.t(`global.languages.long.${language}.label`);
}
